import React from "react"
import { useHistory } from "react-router-dom"
import { useRecoilState, useSetRecoilState } from "recoil"
// import { makeStyles, useTheme } from "@material-ui/core/styles"
// import Collapse from "@material-ui/core/Collapse"
import Grid from "@material-ui/core/Grid"
// import AddIcon from "@material-ui/icons/Add"

import CreateAssociation from "./CreateAssociation"
// import Action from "../../components/Action"
import AssociationCard from "../../components/AssociationCard"
// import Box from "@material-ui/core/Box"
import FormContainer from "../../components/FormContainer"
import Layout from "../../components/PublicLayout"
import { fetchAssociation } from "../../libs/manageAccounts"
import currentAssociation from "../../store/currentAssociation"
import currentUser from "../../store/currentUser"

// const useStyles = makeStyles((theme) => ({
//   container: {
//     margin: "auto",
//     marginTop: theme.spacing(5),
//     maxWidth: 600,
//   },
// }))

export default function Associations() {
  // const theme = useTheme()
  const history = useHistory()
  // const classes = useStyles()
  const setAssociation = useSetRecoilState(currentAssociation)
  const [user] = useRecoilState(currentUser)
  // const [open, setOpen] = React.useState(false)

  const handleClick = (index) => {
    if (user.associations[index]) {
      console.log("user.associationsindex", user.associations[index])
      fetchAssociation(user.associations[index].association.id)
        .then((association) => {
          console.log("association", association)
          setAssociation(association)
        })
        .catch((error) => console.log("error", error))
      history.push("/0")
    }
  }

  // const toggleForm = () => {
  //   setOpen(!open)
  // }

  return (
    <Layout title="Your Associations">
      <Grid container spacing={3}>
        {user.associations && user.associations.length ? (
          user.associations.map((associationUser, index) => {
            const association = {
              name: associationUser.association.name,
              role: associationUser.role,
              unit: associationUser.unit,
            }
            return (
              <Grid item key={associationUser.id} xs={12}>
                <AssociationCard
                  association={association}
                  onClick={() => {
                    handleClick(index)
                  }}
                />
              </Grid>
            )
          })
        ) : (
          // <Grid item xs={12}>
          //   <Collapse in={!open} timeout={theme.transitions.duration.shorter}>
          //     <Box display="flex" justifyContent="center">
          //       <Action onClick={toggleForm} className={classes.addButton} variant="extended">
          //         <AddIcon />
          //         New Association
          //       </Action>
          //     </Box>
          //   </Collapse>
          //   <Collapse in={open}>
          <FormContainer>
            <h1>Create Association</h1>
            <CreateAssociation />
          </FormContainer>
          //   </Collapse>
          // </Grid>
        )}
      </Grid>
    </Layout>
  )
}
